import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Bell, BellOff } from "lucide-react";
import client from "@/lib/api";

export default function Notifications() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    client.get("/notifications").then((r) => {
      setItems(r.data.items);
      if (r.data.unread > 0) client.post("/notifications/read").catch(() => {});
    }).catch(() => nav("/auth?next=/notifications"));
  }, []);

  return (
    <div dir="rtl">
      <div className="sticky top-0 z-20 flex items-center gap-2.5 px-3 py-3" style={{ background: "var(--k-paper)", borderBottom: "1px solid var(--k-line)" }}>
        <button data-testid="back-btn" onClick={() => nav(-1)} className="k-tap w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)" }}><ChevronRight size={20} /></button>
        <h1 className="font-head text-[17px] font-bold flex items-center gap-1.5"><Bell size={17} /> الإشعارات</h1>
      </div>

      {items === null ? (
        <div className="p-6 text-center" style={{ color: "var(--k-ink-soft)" }}>جارٍ التحميل…</div>
      ) : items.length === 0 ? (
        <div className="text-center pt-20 px-8" style={{ color: "var(--k-ink-soft)" }}>
          <BellOff size={44} className="mx-auto mb-3 opacity-50" />
          <p className="text-[13.5px]">لا توجد إشعارات</p>
        </div>
      ) : (
        <div className="px-4 pt-3 pb-8">
          {items.map((n) => (
            <div key={n.id} data-testid={`notif-${n.id}`} className="rounded-2xl p-4 mb-2.5" style={{ background: "var(--k-surface)", border: "1px solid var(--k-line)", borderInlineStartWidth: 4, borderInlineStartColor: n.read ? "var(--k-line)" : "var(--k-gold)" }}>
              <p className="font-head text-[14px] font-bold mb-1">{n.title}</p>
              <p className="text-[12.5px] leading-relaxed" style={{ color: "var(--k-ink-soft)" }}>{n.body}</p>
              <p className="font-num text-[10.5px] mt-2" style={{ color: "var(--k-text-light,#94A3B8)", direction: "ltr", textAlign: "left" }}>{new Date(n.created_at).toLocaleString("ar-LY")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
